import { render, staticRenderFns } from "./ModulesTable.vue?vue&type=template&id=22a01110&scoped=true"
import script from "./ModulesTable.vue?vue&type=script&lang=js"
export * from "./ModulesTable.vue?vue&type=script&lang=js"
import style0 from "./ModulesTable.vue?vue&type=style&index=0&id=22a01110&prod&lang=scss"
import style1 from "./ModulesTable.vue?vue&type=style&index=1&id=22a01110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a01110",
  null
  
)

export default component.exports